var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{staticClass:"data-table",attrs:{"headers":_vm.headers,"items":_vm.dataset,"items-per-page":20,"footer-props":{
        itemsPerPageOptions: [5, 10,20]
    },"dense":true},scopedSlots:_vm._u([{key:"item.date",fn:function({ item }){return [_c('span',[_vm._v(_vm._s(item.month))])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }